import { render, staticRenderFns } from "./default2022NoSearchBar.vue?vue&type=template&id=8df5109a&"
import script from "./default2022NoSearchBar.vue?vue&type=script&lang=ts&"
export * from "./default2022NoSearchBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports